import { gql } from '@apollo/client';

export const DELETE_LEAGUE_MESSAGE = gql`
  mutation DeleteLeagueMessage($input: DeleteLeagueMessageInput!) {
    deleteLeagueMessage(input: $input) {
      success
      errors
    }
  }
`;
